//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const YouTubeVisibility = {
  Private: 'private',
  Public: 'public',
  Unlisted: 'unlisted',
} as const;

export type YouTubeVisibility =
  (typeof YouTubeVisibility)[keyof typeof YouTubeVisibility];
